import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.css']
})
export class TopnavComponent implements OnInit {
  @ViewChild('settingModal', { static: false }) settingModal!: ModalDirective;
  @ViewChild('login', { static: true }) public loginModal!: ModalDirective;
  @ViewChild('changePwd', { static: true }) public changePwdModal!: ModalDirective;

  public api = api;
  public env = environment;
  public user: any;
  private subs: Subscription[] = [];
  isCollapsed = true;
  modalRef?: BsModalRef;
  public stacks: any;
  public stArr: any[] = [];
  public isLoading: boolean = false;
  public menu: any[] = [];
  selected?: string;
  searchData: any[] = [];
  public isLoggedin = false;

  constructor(public router: Router,
    public service: WebserviceService,
    public _common: CommonService,
    private _shared: SharedService,
    private _message: MessageService,
    private modalService: BsModalService,
    public _pusher: PusherService) {

    this.user = (localStorage.getItem(`${this.env.panel}user`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}user`) as any) : '';

    if (this._common.getToken()) {
      this._pusher.userAccUpdate().subscribe(res => {
        if (res) {
          if (res.msg != '') {
            this._message.errmessage(res.msg);
            setTimeout(() => {
              this._common.removeLocalstorage();
              this.router.navigate(['/login']);
              // this.router.navigate(['/home']);
              window.location.reload();
            }, 1000)
          }
          // this.user.balance = parseFloat(res?.balance) + parseFloat(res?.expose) + parseFloat(res?.pl);
          this.user.balance = res?.balance;
          this.user.available_balance = parseFloat(res?.balance) + parseFloat(res?.expose) + parseFloat(res?.pl);
          this.user.expose = res?.expose;
          localStorage.setItem(`${this.env.panel}user`, JSON.stringify(this.user))
        }
      });
    }

    const sub1 = this._shared.sharedLoginModal.subscribe((res: any) => {
      if (res && res?.login && this.loginModal) {
        // this.loginModal!.show();
        this.loginRoute();
        res = undefined;
      }
    });
    this.subs.push(sub1);
    const sub2 = this._shared.sharedCpModal.subscribe((res: any) => {
      if (res && res?.isCp) {
        this.changePwdModal!.show();
        res = undefined;
      }
    });
    this.subs.push(sub2);
  }

  ngOnInit(): void {
    let dts = (localStorage.getItem(`${this.env.panel}sideMenu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideMenu`) as any) : [];
    this.searchData = dts;
    this.menu = (localStorage.getItem(`${this.env.panel}menu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}menu`) as any) : [];
    if (this.menu.length == 0) { this.getMenu(); }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: `${this.env.modalClass}` }));
  }

  closeModal() {
    this.modalRef?.hide();
  }

  openAppMoadal(template: TemplateRef<any>) {
    this.modalRef?.hide();
    this.openModal(template);
  }

  setting() {
    this.stacks = (localStorage.getItem(`${this.env.panel}stakes`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}stakes`) as any) : [];
    this.stArr = Array(8).fill(0);
    this.settingModal.show();
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  setBtnVal() {
    this.isLoading = true;
    let req = this._common.JSON_to_URLEncoded(this.stacks)
    this.service.Post(`${this.env.baseUrl + this.api.stakesUpdate}`, req)
      .subscribe(
        (res) => {
          this.isLoading = false;
          if (res.status == true) {
            this._message.succmessage("Stack Updated successfully");
            this.settingModal.hide();
            localStorage.setItem(`${this.env.panel}stakes`, JSON.stringify(this.stacks))
            // this.betData.stakes = this._common.getStakeArray();
          }
          // this.loaderService.hideLoader();
        },
        (err) => {
          // this.loaderService.hideLoader();
          // this._message.errmessage(err);
        }
      );

  }

  getMenu() {
    this.getServices().Get(`${this.env.baseUrl + this.api.menu}`).subscribe(
      (res) => {
        if (res.status == true) {
          if (!localStorage.getItem(`${this.env.panel}stakes`)) {
            localStorage.removeItem(`${this.env.panel}stakes`);
            localStorage.setItem(`${this.env.panel}stakes`, JSON.stringify(this.env.stakes));
          }
          localStorage.removeItem(`${this.env.panel}menu`);
          localStorage.setItem(`${this.env.panel}menu`, JSON.stringify(res?.data?.menu));
          this.menu = res?.data?.menu;
          this._shared.emitSideMenu('');
        }
      },
      (err) => {
        console.log(err);
      });
  }

  loginRoute() {
    this.router.navigate(['/login'])
  }

  logOut() {
    this.getServices().Get(`${this.env.baseUrl + this.api.logout}`).subscribe(
      (res) => {

        this._common.removeLocalstorage();
        this.router.navigate(['/login']);
        // this.router.navigate(['/home']);
        this._message.succmessage(res.message);
        window.location.reload();
      },
      (err) => {
        console.log(err);
      });
  }

  redirectDetail(e: any) {
    this.selected = ''
    // this._router.navigate(['/event/detail', e.event_id])
  }

  ngDoCheck() {
    this.user = (localStorage.getItem(`${this.env.panel}user`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}user`) as any) : '';
    this.isLoggedin = localStorage.getItem(`${this.env.panel}id_token`) ? true : false;
    let dts = (localStorage.getItem(`${this.env.panel}sideMenu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideMenu`) as any) : [];
    this.searchData = dts;
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}
